import { formatMoney } from '@/utils/currency';
import { receiptLinePromo } from '@/utils/receiptPromo';

export default function ReceiptPromoPrice({
  item,
  show,
  field = 'amount',
  className = '',
}: {
  item: {
    quantity?: number;
    rate?: number;
    amount?: number;
    original_rate?: number;
    promo_amount?: number;
  };
  show: boolean;
  field?: 'rate' | 'amount';
  className?: string;
}) {
  const line = receiptLinePromo(item);
  const charged = field === 'rate' ? line.chargedRate : line.chargedAmount;
  const original = field === 'rate' ? line.originalRate : line.originalAmount;
  if (show && line.hasPromo) {
    return (
      <span className={`inline-flex flex-col items-end leading-tight ${className}`}>
        <span className="text-[10px] text-gray-400 line-through font-normal">{formatMoney(original)}</span>
        <span>{formatMoney(charged)}</span>
      </span>
    );
  }
  return <span className={className}>{formatMoney(charged)}</span>;
}
